module.exports = __webpack_public_path__ + "static/media/varietyVikings.166eec5e.png";